/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Read_Along_AuthorsInputs */

const en_read_along_authors = /** @type {(inputs: Read_Along_AuthorsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Authors`)
};

const es_read_along_authors = /** @type {(inputs: Read_Along_AuthorsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Autores`)
};

/**
* | output |
* | --- |
* | "Authors" |
*
* @param {Read_Along_AuthorsInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const read_along_authors = /** @type {((inputs?: Read_Along_AuthorsInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Read_Along_AuthorsInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_read_along_authors(inputs)
	return en_read_along_authors(inputs)
});